import { render } from "./MagnifyMinusOutline.vue?vue&type=template&id=6b47cb72"
import script from "./MagnifyMinusOutline.vue?vue&type=script&lang=js"
export * from "./MagnifyMinusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__